import http from '@/utils/http'

// get请求
export default{
	//
	getJson(params){
		return http.get('/',params)
	},
	memberLogin(params){
		return http.post('/member/login',params)
	},
	getCellCode(params){
		return http.post('/member/cellcode',params)
	},
	getLoginCellCode(params){
		return http.post('/action/sendCellCode',params)
	},
	memberReg(params){
		return http.post('/member/reg',params)
	},
	getDetail(id,params){
		return http.get('/designer/' + id,params)
	},
	getDetailMarks(params){
		return http.get('/list/desmarks',params)
	},
	createOrder(params){
		return http.post('/action/rz',params)
	},
	getDesList(params){
		return http.get('/des',params)
	},
	getCase(params){
		return http.get('/case/getCase',params)
	},
	saveDemand(params){
		return http.post('/guide/zdzj',params)
	},
}


// WEBPACK FOOTER //
// ./src/api/api.js